import { styled } from '@mui/material/styles';

import ButtonBase from '@/components/ui/Button/Button';

export const Button = styled(ButtonBase)(() => ({
  maxWidth: 324,
}));
